module.exports = __webpack_public_path__ + "static/media/phone.861a2ae9.svg";